<div *ngIf="eChartOptions && chartweatherData && chartweatherData.daily && chartweatherData.daily.length > 0"
  class="chartDiv">
  <div class="card chartCard mx-auto">
    <div class="card-body chartCardBody">
      <div echarts [options]="eChartOptions" class="demo-chart chart"></div>
    </div>
  </div>
</div>